import { supabase } from '../lib/supabase';

export const metricsService = {
  async getAllMetrics() {
    const { data, error } = await supabase?.from('dashboard_metrics')?.select('*');

    if (error) throw error;
    
    // Convert to object format for easier access
    const metricsObj = {};
    data?.forEach(metric => {
      metricsObj[metric.metric_name] = metric?.metric_value;
    });
    
    return metricsObj;
  },

  async updateMetric(metricName, newValue) {
    const { data, error } = await supabase?.from('dashboard_metrics')?.update({ metric_value: newValue, updated_at: new Date()?.toISOString() })?.eq('metric_name', metricName)?.select()?.single();

    if (error) throw error;
    return data;
  },

  async incrementMetric(metricName, incrementBy = 1) {
    // Get current value
    const { data: currentData, error: fetchError } = await supabase?.from('dashboard_metrics')?.select('metric_value')?.eq('metric_name', metricName)?.single();

    if (fetchError) throw fetchError;

    const newValue = (currentData?.metric_value || 0) + incrementBy;

    // Update with new value
    return await this.updateMetric(metricName, newValue);
  }
};